export const NAVBAR_MENU_BURGER_DEFAULTS_V2 = {
  mobileJustify: 'end',
  color: '#171717',
  size: 16,

  background: '#ffffff',
  padding: '16px',
  gap: '4px',
  border: 'none',
  borderColor: 'transparent',
  borderWidth: '0px',
  borderStyle: 'none',
  borderRadius: '0px',
  itemsAlignment: 'left',
};
